// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./public/less/doctorAdvice.less
// module id = 1200
// module chunks = 0